var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseSmallDarkblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons-navigation/Up-collapse-small/Darkblue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.6571293,6.8904 C12.4951293,6.8904 12.3324627,6.83173333 12.203796,6.71306667 L6.653796,1.57573333 L1.119796,6.71173333 C0.850462666,6.96106667 0.428462666,6.9464 0.177796,6.67773333 C-0.0722040002,6.40706667 -0.0568706669,5.98573333 0.213129333,5.73573333 L6.19912933,0.177733333 C6.45512933,-0.0589333333 6.85046267,-0.0589333333 7.105796,0.177066667 L13.1104627,5.7344 C13.3804627,5.98506667 13.3964627,6.4064 13.1464627,6.67706667 C13.0151293,6.81906667 12.8364627,6.8904 12.6571293,6.8904",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-navigation/Up-collapse-small/Darkblue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(5.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#003755",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseSmallDarkblue);
export default __webpack_public_path__ + "static/media/collapse-small_darkblue.c27dcb36a88a4a04dfdd0e0e248d52a3.svg";
export { ForwardRef as ReactComponent };